import React, { Component } from "react";
import Spinner from "../../Common/Spinner";
import "react-datepicker/dist/react-datepicker.css";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import { Messages } from "primereact/messages";
import { Growl } from "primereact/growl";
import * as appConst from "../../Common/constants";

export default class Add extends Component {
  constructor(props) {
    super(props);

    var _name, _inuse, _damage, _stock, _mode;
    if (this.props.pData._id === "NA") {
      _name = "";
      _inuse = 0;
      _damage = 0;
      _stock = 0;
      _mode = "add";
    } else {
      _name = this.props.pData.name;
      _inuse = this.props.pData.stock.inuse;
      _damage = this.props.pData.stock.damage;
      _stock = this.props.pData.stock.stock;
      _mode = "edit";
    }

    this.state = {
      name: _name,
      inuse: _inuse,
      damage: _damage,
      stock: _stock,
      mode: _mode,
      spinnerClass: "collapse",
      dataClass: ""
    };
  }

  render() {
    return (
      <div>
        <div>
          <h5 align="center"> {this.getHeading()}</h5>
        </div>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2">Name</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  value={this.state.name}
                  onChange={e => this.setState({ name: e.target.value })}
                  style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">In Stock</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="pint"
                  value={this.state.stock}
                  onChange={e => this.setState({ stock: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Damaged</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="pint"
                  value={this.state.damage}
                  onChange={e => this.setState({ damage: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">In Use</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="pint"
                  value={this.state.inuse}
                  onChange={e => this.setState({ inuse: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>

            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className={this.getCancelClass()}
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
            <Messages ref={el => (this.messages = el)} />
          </div>
        </div>
      </div>
    );
  }

  getCancelClass() {
    let clsName = "btn btn-primary btn-md mr-2 ";
    if (this.props.source === "list") {
      clsName += "visible";
    } else {
      clsName += "invisible";
    }
    return clsName;
  }

  getHeading() {
    if (this.props.pData._id === "NA") return "Add Equipment";
    else return "Edit Equipment";
  }

  onSaveClick = e => {
    e.preventDefault();
    if (this.state.name === "") {
      this.messages.show({
        severity: "error",
        summary: "Error !!",
        detail: "Select Mandatory Fields"
      });
    } else {
      const objStock = {
        inuse: this.state.inuse,
        damage: this.state.damage,
        stock: this.state.stock
      };

      const obj = {
        name: this.state.name,
        stock: objStock
      };

      if (this.state.mode === "add") {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
              
              "/equipment/add",
            obj
          )
          .then(res => console.log(res.data));
        this.ClearData();
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Equipment Added !!!"
        });
      } else {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
              
              "/equipment/update/" +
              this.props.pData._id,
            obj
          )
          .then(res => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Equipment Updated !!!"
            });
            this.props.onClick("List", null);
          });
      }
    }
  };

  ClearData() {
    this.setState({
      name: "",
      inuse: 0,
      stock: 0,
      damage: 0
    });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}
